import { useAuditLog } from '../lib/data';
import { formatTime } from '../lib/format';

export function AuditLog() {
  const entries = useAuditLog();
  return (
    <div className="audit">
      <h2>Config change audit log</h2>
      <table className="session-table">
        <thead><tr><th>When</th><th>Path</th><th>Changes</th></tr></thead>
        <tbody>
          {entries.length === 0 && <tr><td colSpan={3}>No changes recorded.</td></tr>}
          {entries.map((e, i) => (
            <tr key={i}>
              <td>{formatTime(e.createdAt)}</td>
              <td>{e.path}</td>
              <td>
                {e.changes.map((c, j) => (
                  <div key={j}>
                    <code>{c.field}</code>: {JSON.stringify(c.before)} → {JSON.stringify(c.after)}
                  </div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
